import { cn } from "@/lib/utils"

export function Card({
  children,
  className,
  ...props
}: React.ComponentProps<"article">) {
  return (
    <article className={cn("relative rounded-lg bg-card p-6 text-card-foreground shadow-none", className)} {...props}>
      {children}
    </article>
  )
}
